import { PopulatedAssessment } from '../types'
import { FieldMap } from '../types/forms/fields'
import { getNestedFields, makeFieldsOptional } from '../utils/fields'
import { getAssessmentFields } from './assessment/field'

export const getNestedUserFields = (
  admin: boolean,
  assessment: Omit<PopulatedAssessment, 'availableForms' | 'stages' | 'midwifeId' | 'plans'> | null,
): FieldMap => {
  const assessmentFields = getAssessmentFields(admin, assessment)
  const nestedFields = getNestedFields(assessmentFields)

  return makeFieldsOptional(
    nestedFields,
    admin
      ? [
          'insuranceInfo.primaryCoverage.insuranceCard.front',
          'insuranceInfo.primaryCoverage.insuranceCard.back',
          'insuranceInfo.medicaidCoverage.insuranceCard.front',
          'insuranceInfo.medicaidCoverage.insuranceCard.back',
        ]
      : [],
  )
}
